import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from '../layout';
import { ClipLoader } from 'react-spinners';
// import { StoreProvider } from '../store';

const HomeLazy = lazy(() => import('../pages/home'));
const RegistrationFormLazy = lazy(() => import('../pages/registration'));
const ExpiredInvitationLazy = lazy(() => import('../pages/expired-invitation'));
const RegisteredLazy = lazy(() => import('../pages/registered'));
const NotFoundLazy = lazy(() => import('../pages/not-found'));

export const AppRoutes = () => {
  return (
    <Router>    
      <Suspense>
        <Layout>
          <Routes>
              <Route path="/" element={<HomeLazy />} />
              <Route path="/register" element={<RegistrationFormLazy />} />
              <Route path="/expired-invitation" element={<ExpiredInvitationLazy />} />
              <Route path="/registered" element={<RegisteredLazy />} />
              <Route path="/*" element={<NotFoundLazy />} />
          </Routes>
        </Layout>
      </Suspense>
    </Router>
  )
}
  

